/** @format */
// 新建/编辑联系人的信息
export interface UpdateUserProps {
  Id?: number
  Name?: string
  Email?: string
  Phone?: string
  ContactGroupIds?: number[]
  VerifyCode?: string
}

// table item
export interface TableItemProps {
  userid?: number
  name?: string
  phone?: string
  email?: string
  usergroup?: any[]
}
// 编辑联系人props
export interface ContactDrawerProps {
  className?: string
  visible: boolean
  closeDrawer: (update?: boolean) => void
  curUser: TableItemProps
}

// 新建/编辑联系人默认form
export const initConstactsForm: UpdateUserProps = {
  Name: '',
  Email: '',
  Phone: '',
  ContactGroupIds: []
}

// 联系组props
export interface UserGroupProps {
  name?: string
  userCount?: number
  usrgrpid?: number
  description?: string
}

// 编辑联系组 drawer props
export interface ContactGroupDrawerProps {
  className?: string
  visible: boolean
  closeDrawer: (update?: boolean) => void
  curGroup: ContactGroupUpdate
  userList: any[]
}

// 编辑当前组props、编辑当前组下联系人
export interface ContactGroupUpdate extends UserGroupProps {
  className?: string
  contactIds?: TableItemProps[]
  updateGroupList?: () => void
}

// 新建/编辑联系组 form
export interface updateGroupProps {
  Name?: string
  Description?: string
  UserIdList?: number[]
}

// 新建/编辑联系组 默认值
export const initConstactGroupForm: updateGroupProps = {
  Name: '',
  Description: '',
  UserIdList: []
}
